import React from "react";
//import About from "../components/About";
import InspironIntro from "../components/InspironIntro";

import hackathon_bg from "../images/bg.png";
import Timeline from "../components/Timeline";
import Prizes from "../components/Prizes";
import About from "../components/About";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Ranks from "./Ranks.js";
import RegisterNow from "../components/RegisterNow";
export default function Home(props) {
  return (
    <div>
      <div
        style={{
          backgroundImage: `url(${hackathon_bg})`,
          backgroundSize: 'cover',
          backgroundAttachment: 'fixed',
          minHeight:"100vh",
          minWidth:"100%",
          backgroundRepeat:"no-repeat"
        }}
      >
        <Navbar {...props}/>
       <InspironIntro></InspironIntro>
       <center>
        <button className='btn1 text-lato text-bold' style={{fontSize:"1.4rem",paddingLeft:"20px",paddingRight:"20px",fontWeight:"bold"}} onClick={()=>window.open("https://drive.google.com/file/d/1EyjfO6c6Wwj25ZPWfQzic1qgmWRDRXDN/view")}>PROBLEM STATEMENTS</button>
        </center>
        <About></About>
       {/* <Ranks/>*/}
     
        <Timeline></Timeline>
      
       {/* <Prizes></Prizes>*/}
      <Footer className="glass"/>
      </div>
    </div>
  );
}
